import React from "react";
import { SiQuickbooks, SiXero } from "react-icons/si";
import { Receipt, ShieldCheck, FileSpreadsheet, Calculator } from "lucide-react";

const ITEMS = [
  { Icon: SiQuickbooks, label: "QuickBooks Online" },
  { Icon: SiXero, label: "Xero" },
  { Icon: Receipt, label: "Dext" },
  { Icon: ShieldCheck, label: "CRA Compliant" },
  { Icon: FileSpreadsheet, label: "HST / GST Filing" },
  { Icon: Calculator, label: "Fixed Monthly Pricing" },
];

export default function TrustStrip() {
  const loop = [...ITEMS, ...ITEMS];
  return (
    <section
      className="border-y border-border bg-cream/60 py-8 overflow-hidden"
      data-testid="trust-strip"
    >
      <div className="px-6 md:px-12 lg:px-20 max-w-7xl mx-auto">
        <div className="text-center text-[11px] uppercase tracking-[0.3em] text-stone mb-6">
          Trusted tools &amp; compliance standards
        </div>
        <div className="relative">
          <div className="flex gap-12 marquee-track whitespace-nowrap">
            {loop.map((it, i) => (
              <div
                key={i}
                className="flex items-center gap-3 text-navy/80 shrink-0"
                data-testid={`trust-item-${i}`}
              >
                <it.Icon className="h-7 w-7" />
                <span className="font-serif text-xl tracking-tight">{it.label}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
